import React from 'react';
import { generateUserColor, getInitials } from '../utils/helpers';

interface UserAvatarProps {
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  avatar?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  onClick?: () => void;
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  firstName,
  lastName,
  username,
  email,
  avatar,
  size = 'md',
  className = '',
  onClick
}) => {
  // Use username or email as identifier for color generation
  const identifier = username || email || '';
  const backgroundColor = generateUserColor(identifier);
  const initials = getInitials(firstName, lastName, username || email);

  // Size classes
  const sizeClasses = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-9 w-9 text-sm',
    lg: 'h-12 w-12 text-base',
    xl: 'h-14 w-14 text-lg'
  };

  const baseClasses = `flex items-center justify-center rounded-full font-semibold text-white border border-[#E9E9E9] ${sizeClasses[size]} ${className}`;

  // If avatar is provided, show image
  if (avatar) {
    return (
      <div 
        className={`${baseClasses} overflow-hidden`}
        onClick={onClick}
        style={{ cursor: onClick ? 'pointer' : 'default' }}
      >
        <img
          src={avatar}
          alt="User Avatar"
          className="h-full w-full object-cover"
        />
      </div>
    );
  }

  // Otherwise show colored initials
  return (
    <div
      className={baseClasses}
      style={{ 
        backgroundColor,
        cursor: onClick ? 'pointer' : 'default'
      }}
      onClick={onClick}
    >
      {initials}
    </div>
  );
};

export default UserAvatar; 